import React from "react";

import { InfoBlackIcon } from "../../../assets/icons";

interface SubcategoryDescriptionProps {
    primaryColor?:string;
    description: string;
}

const SubcategoryDescription: React.FC<SubcategoryDescriptionProps> = ({ description,primaryColor }) => {

    let bgColor = primaryColor + "19";

    return (
        <div className="client-product-subcategory-description-div" style={{ color: primaryColor, borderColor: primaryColor, backgroundColor: bgColor }}>
            <img src={InfoBlackIcon} loading="lazy" alt="" className="icon-size-28" />
            <div>{description}</div>
        </div>

    );
};

export default SubcategoryDescription;